import { CollaborationResult } from '@/infrastructure/gateways/classroom/models/collaboration-result';
import { Lesson } from '@/presentation/screens/classroom/classroom.vm';

const collaborationName = 'GetClassroomByTopic';

export const ObtainedCurrentLessonIdentifier = 'ObtainedCurrentLesson';
export class ObtainedCurrentLesson extends CollaborationResult<Lesson> {
  constructor(data: Lesson) {
    super(
      collaborationName,
      ObtainedCurrentLessonIdentifier,
      'Current lesson successfully obtained',
      data,
    );
  }
}

export const CurrentLessonNotFoundIdentifier = 'CurrentLessonNotFound';
export class CurrentLessonNotFound extends CollaborationResult<undefined> {
  constructor() {
    super(collaborationName, CurrentLessonNotFoundIdentifier, 'Current lesson not found');
  }
}

export const CurrentLessonUnexpectedErrorIdentifier = 'CurrentLessonUnexpectedError';
export class CurrentLessonUnexpectedError extends CollaborationResult<undefined> {
  constructor() {
    super(collaborationName, CurrentLessonUnexpectedErrorIdentifier, 'An unexpected error occurs');
  }
}
